export const INSTAGRAM_URL = "https://www.instagram.com/dmimportsl/";
export const INSTAGRAM_HANDLE = "@dmimportsl";

export const waConfig = { number: "5567996863443" };

export const waDisplay = () => {
  const d = waConfig.number.replace(/\D/g, "");
  return d.length === 13 ? `(${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}` : d;
};

export const waLink = (msg) => `https://wa.me/${waConfig.number}?text=${encodeURIComponent(msg)}`;

export const waPlain = () => `https://wa.me/${waConfig.number}`;

export const waGeneral = () =>
  waLink("Olá! Vim pelo site da DM Imports e gostaria de conhecer os modelos disponíveis.");

export const waProduct = (nome, codigo) =>
  waLink(`Olá! Vi o ${nome}${codigo ? ` (Cód: ${codigo})` : ""} no site da DM Imports e gostaria de saber o valor e a disponibilidade.`);

export const waEncomenda = () =>
  waLink("Olá! Gostaria de fazer uma encomenda com a DM Imports. Estou procurando o seguinte modelo:");

export const waProntaEntrega = () =>
  waLink("Olá! Gostaria de consultar os modelos de pronta entrega disponíveis na DM Imports.");
